import { render } from "./Canvas.vue?vue&type=template&id=1bc823c3&scoped=true"
import script from "./Canvas.vue?vue&type=script&lang=js"
export * from "./Canvas.vue?vue&type=script&lang=js"

import "./Canvas.vue?vue&type=style&index=0&id=1bc823c3&scoped=true&lang=css"

import exportComponent from "C:\\laragon\\www\\collage-dani-pablo\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1bc823c3"]])

export default __exports__